<div class="TotemWidget TotemWidgetImagelist card {{ fullScreen ? 'TotemWidgetImagelist--FullScreen' : '' }}">
    @if (imageList != null && imageList.length > 0) {
        <div (scroll)="onScroll()" #scrollContainer>
            <div class="TotemWidgetImagelist-Inner">
                @for (image of imageList; track image; let i = $index) {
                    <div class="TotemWidgetImagelist-Inner-Item"
                        role="button"
                        tabindex="0"
                        [attr.aria-label]="(image.text | locTranslate) || ('totem-a11y.imagelist-open' | locTranslate)"
                        (click)="requestFullScreen.emit({ params: i })"
                        (keydown.enter)="requestFullScreen.emit({ params: i })"
                        (keydown.space)="$event.preventDefault(); requestFullScreen.emit({ params: i })">
                        <div class="TotemWidgetImagelist-Inner-Item-Image">
                            <app-pg-image-autosize [src]="image.file" [fit]="fullScreen ? 'contain' : 'cover'" [alt]="image.text | locTranslate"></app-pg-image-autosize>
                        </div>
                        <div class="TotemWidgetImagelist-Inner-Item-Text">
                            <div class="p-2">
                                <h5 class="m-0">{{image.text | locTranslate}}</h5>
                                <div class="opacity-80">{{image.author}}</div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</div>
